import { ILogoutRequestedAction, LogoutTypes } from "./logout.type";

export function logoutRequested(): ILogoutRequestedAction {
  return {
    type: LogoutTypes.LOGOUT_REQUESTED,
  };
}
